export default __webpack_public_path__ + "static/media/icon-coin-satoshi.3aef2f8e.svg";